import scroll from './scroll';

function init() {
    const tabWrapper = document.querySelectorAll('.js-tab-wrapper');
    if (tabWrapper.length > 0) {
        tabWrapper.forEach((wrapper) => {
            const tabContent = wrapper.querySelectorAll('.js-tab');
            const tabLink = wrapper.querySelectorAll('.js-tab-link');

            function destroy() {
                if (tabContent.length > 0) {
                    tabContent.forEach((content) => {
                        content.classList.remove('is-open');
                    });
                }
                if (tabLink.length > 0) {
                    tabLink.forEach((link) => {
                        link.classList.remove('is-active');
                    });
                }
            }

            if (tabLink.length > 0) {
                tabLink.forEach((link) => {
                    link.addEventListener('click', function (e) {
                        e.preventDefault();
                        destroy();
                        link.classList.add('is-active');
                        const tabCurrent = wrapper.querySelector('.js-tab[data-tab="' + link.dataset.open + '"]');
                        if (tabCurrent) {
                            tabCurrent.classList.add('is-open');
                            scroll.update();
                        }
                    });
                });
            }
        });
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                } else {
                    if (!entry.target.classList.contains('is-open')) {
                        entry.target.classList.remove('is-visible');
                    }
                }
            });
        },
        { rootMargin: '0% 0% 0% 0%', threshold: [0, 1] },
    );

    const tab = document.querySelectorAll('.js-tab');
    if (tab.length > 0) {
        tab.forEach((element) => {
            observer.observe(element);
        });
    }
}

export default { init };
